// 3. PayrollPreview.jsx
const PayrollPreview = () => {
  return (
    <div className="p-4 min-h-screen bg-white">
      <div className="flex items-center gap-4 mb-4">
        <button>&larr;</button>
        <h1 className="text-lg font-bold">Payroll Preview</h1>
      </div>

      <div className="bg-primary text-white text-center py-3 rounded-t-xl font-bold text-xl">
        Stellaris
      </div>
      <div className="bg-gray-50 px-4 py-4 rounded-b-xl shadow">
        <h2 className="text-center font-semibold mb-2">John DoE</h2>
        <p className="text-center text-sm text-gray-500 mb-4">23 May 2024 - 23 May 2024</p>

        <div className="flex justify-between text-sm font-semibold border-b py-2">
          <span>Title</span>
          <span>Amount</span>
        </div>
        <div className="flex justify-between text-sm py-2">
          <span>30 Days Salary</span>
          <span>$25.99</span>
        </div>

        <div className="flex justify-between font-bold mt-4">
          <span>Total</span>
          <span>$25.99</span>
        </div>
      </div>

      <button className="w-full bg-primary text-white py-3 mt-6 rounded">Download</button>
    </div>
  );
};

export default PayrollPreview;